import { type GetServerSidePropsContext } from 'next';

import { getBudgetData } from '../../modules/budget';

import { withEnhancedPageHandler } from '../../middlewares/withEnhancedPageHandler';

import { applyCorrelationIdHeader } from '../../utils/server/applyCorrelationIdHeader';

import { BudgetTemplate } from '../../templates';

import { type IBudgetPageProps } from '../../modules/budget/pageProps/@interfaces';
import { type TLocale } from '../../modules/shared/@interfaces';
import { type IUserCliDataResponse, user } from '../../modules/user';

export interface IBudgetProps extends IBudgetPageProps {
  userData: IUserCliDataResponse;
}

const Budget = (props: IBudgetProps) => <BudgetTemplate {...props} />;

const getServerSidePropsHandler = async ({
  params,
  query,
  locale,
  res,
  req,
}: GetServerSidePropsContext) => {
  const { slug } = params;

  const categorySlugIndex = slug.length - 1;
  const categorySlug = (slug.slice(0, categorySlugIndex) as string[]).join('/');
  const rootCategorySlug = slug[0];
  const budgetSlug = slug[categorySlugIndex];
  const shouldRefresh = query.refresh === 'true' || false;

  const customHeaders = applyCorrelationIdHeader(req.headers);

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const props = await getBudgetData({
    locale: locale as TLocale,
    refresh: shouldRefresh,
    slug: budgetSlug,
    categorySlug,
    customHeaders,
  });

  if (!props) {
    return {
      redirect: {
        destination: `/${rootCategorySlug}`,
        permanent: true,
      },
    };
  }

  const { userData: userResponse } = user.getData(req);
  const { notificationCount } = await user.getNotifications(req);

  const userData = userResponse
    ? {
        ...userResponse,
        isAuthenticated: true,
        notificationCount,
      }
    : {
        avatar: null,
        name: null,
        phone: null,
        isAuthenticated: false,
        notificationCount,
      };

  return {
    props: {
      ...props,
      userData,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default Budget;
